import HeroPill from "@/components/atoms/HeroPill";
import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import classNames from "classnames";
import { useRouter } from "next/router";
import React from "react";
import { RightSection } from "./RightSection";

type ratingsType ={
  logo : string;
  rating : string;
}

type featureType = {
  text:string
}

type MarketingHeadingUsProps = {
  data: {
    type: string;
    heading: string;
    headingType: string;
    subheading: string;
    pillText: string;
    mainHeroHeader?:string;
    leadEndpointUrl?: string;
    defaultCountry?: string;
    coverVideo: {
      videoId: string;
      wrapper: string;
    };
    ratings ?:ratingsType[];
    ctas: CtaType[];
    discountInfo: string;
    features ?: featureType[]
  };
};

const MarketingHeadingUs: React.FC<MarketingHeadingUsProps> = ({ data }) => {
  

  


  const router = useRouter();
  const path = router.asPath;
  const url = router.query.page;
  const isOnlineCoursePlatform = url === "online-course-platform";
  const isWebinarRebeccaSchocker = url === "webinar-rebecca-schocker"

  const isPathWebinar = path.includes("webinar");
  const ratings = [
     {
       logo: "/images/categories/home-testimonials/g2-crowd.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
     {
       logo: "/images/categories/home-testimonials/capterra.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
     {
       logo: "/images/categories/home-testimonials/trustpilot.svg",
       rating: "/images/categories/home-testimonials/rating-stars.svg",
     },
   ];

const finalRatings = data.ratings ? data.ratings : ratings;

  return (
    <div className="mx-auto flex max-w-[1440px] flex-col items-center justify-between gap-8 px-5 lg:flex-row lg:px-[90px] mt-12">
      <div className="flex flex-col items-center">
        <div>
          {data?.subheading && (
            <>
              {data?.pillText && (
                <div className="flex justify-center sm:justify-start">
                  <HeroPill category={data?.pillText} className="mb-5" />
                </div>
              )}
            </>
          )}
          <div className="flex flex-col gap-10 text-center sm:text-left">
            <p className="text-title-32 font-semibold sm:text-title40">
              {data?.heading}
            </p>
            <p className="text-body-16 text-grey-4">{data?.subheading}</p>
            <div className={`flex ${isPathWebinar ? "flex-row" : "flex-col"} gap-6`}>
            {data?.features && data?.features?.map(({text}:{text:string}) => {
              return (
                <div key={text} className="flex w-full items-start gap-1">
                  <div className="h-5 w-5">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.7578 12.9461C2.13062 11.3189 2.13062 8.68074 3.7578 7.05356L7.05363 3.75774C8.68081 2.13055 11.319 2.13055 12.9462 3.75773L16.242 7.05356C17.8692 8.68074 17.8692 11.3189 16.242 12.9461L12.9462 16.2419C11.319 17.8691 8.68081 17.8691 7.05363 16.2419L3.7578 12.9461Z"
                        stroke="#6059FF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.0939 8.92236L9.47696 11.5393L7.90381 9.97113"
                        stroke="#6059FF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="text-body">{text}</span>
                </div>
              );
            })}
            </div>
            <div>
              {(isOnlineCoursePlatform || isWebinarRebeccaSchocker) ? null :
                <CtaButtonGroup align="sm:left" ctas={data?.ctas} affiliateButton={true} />
              }
              {(isWebinarRebeccaSchocker) ? " " : data?.discountInfo && (
                <div className="mt-4 flex items-center justify-center gap-2 sm:justify-start">
                  <img
                    src="/images/icons/percentage-pink.svg"
                    alt="company logo"
                    className="h-4 w-4"
                  />
                  <p className="text-body-12 font-normal text-grey-4">
                  {isPathWebinar ? <>
                      Hurry! <span className="font-bold">Limited slots available</span> - grab your seat now.
                    </> : data?.discountInfo}
                  </p>
                </div>
              )}
            </div>
            {data?.headingType!== "affiliate" && <div className="flex justify-center sm:justify-start">
              {finalRatings?.map((company, idx) => (
                <div
                  className={classNames(
                    `flex flex-col  items-end justify-between`,
                    idx === 0 ? "pr-4" : "px-4"
                  )}
                  key={company?.logo}
                >
                  <img
                    src={company?.logo}
                    alt="company logo"
                    className="mb-1 h-5 w-24 lg:h-10"
                  />
                  <img src={company?.rating} alt="company rating" />
                </div>
              ))}
            </div>}
          </div>
        </div>
      </div>
      <RightSection
        isOnlineCoursePlatform={isOnlineCoursePlatform}
        data={data}
        isPathWebinar={isPathWebinar}
        isWebinarRebeccaSchocker={isWebinarRebeccaSchocker}
      />
    </div>
  );
};
export default MarketingHeadingUs;
